module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-bg@3x-ce4d0a9af311c552e2ebb20245eb5b30.png";